import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import useSchedulerAnalytics from "../hooks/useSchedulerAnalytics";
import { inferPageNameFromPathname } from "../lib/analytics/posthog";

const PostHogRouteTracker = (): null => {
  const location = useLocation();
  const { trackPageOpened } = useSchedulerAnalytics();
  const lastUrlRef = useRef<string>("");

  useEffect(() => {
    if (typeof window === "undefined") return;

    const currentUrl = `${window.location.pathname}${window.location.search}`;
    if (lastUrlRef.current === currentUrl) return;

    lastUrlRef.current = currentUrl;
    trackPageOpened({
      pageName: inferPageNameFromPathname(window.location.pathname),
    });
  }, [location.pathname, location.search, trackPageOpened]);

  return null;
};

export default PostHogRouteTracker;

